module.exports = __webpack_public_path__ + "img/f1101344-33de-444d-9177-b6d84221114b.1b0ac935.jpeg";